module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-content', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('center', [(_vm.transportMatrix == '') ? _c('img', {
    staticStyle: {
      "padding-top": "7%"
    },
    attrs: {
      "src": require("../../shared/assets/images/3dloader.gif")
    }
  }) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "relative"
  }, [(_vm.search != '') ? _c('a', {
    staticClass: "searchTypeClear",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncClearSearch.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons searchTypeClearText"
  }, [_vm._v("close")])]) : _vm._e(), _vm._v(" "), (_vm.transportMatrix != '' && _vm.search != '') ? _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.transportMatrix != '' && _vm.search == '') ? _c('v-text-field', {
    attrs: {
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e(), _c('br')], 1)]), _vm._v(" "), (_vm.transportMatrix != '') ? _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "search": _vm.search,
      "items": _vm.transportMatrix.tcmItems,
      "disable-initial-sort": "",
      "rows-per-page-items": [20, 40, 60, 80, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "35%"
          }
        }, [_c('v-select', {
          attrs: {
            "items": _vm.transportMatrix.products,
            "label": "Product",
            "autocomplete": "",
            "solo": "",
            "item-value": "id"
          },
          model: {
            value: (props.item.product_code),
            callback: function($$v) {
              _vm.$set(props.item, "product_code", $$v)
            },
            expression: "props.item.product_code"
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "15%"
          }
        }, [_c('v-select', {
          attrs: {
            "items": _vm.transportMatrix.uom,
            "label": "UOM",
            "autocomplete": "",
            "solo": "",
            "item-text": "name",
            "item-value": "id"
          },
          model: {
            value: (props.item.uom),
            callback: function($$v) {
              _vm.$set(props.item, "uom", $$v)
            },
            expression: "props.item.uom"
          }
        })], 1), _vm._v(" "), _vm._l((_vm.radiusLength), function(radius) {
          return _c('td', {
            staticClass: "text-xs-right matrixTd",
            attrs: {
              "width": "remainingWidth"
            }
          }, [_c('v-text-field', {
            attrs: {
              "required": "",
              "solo": ""
            },
            model: {
              value: (props.item.radius_cost[parseInt(radius) - 1]),
              callback: function($$v) {
                _vm.$set(props.item.radius_cost, parseInt(radius) - 1, $$v)
              },
              expression: "props.item.radius_cost[parseInt(radius)-1]"
            }
          })], 1)
        }), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_QUOTE_STATUSES') !== -1) ? _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "5%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncDeleteMatrix(props.item.product_code)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("delete_forever")])])]) : _vm._e()]
      }
    }], null, false, 200811179)
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}